// extracted by mini-css-extract-plugin
module.exports = {"main":"separator-module--main--3qCsn","separator":"separator-module--separator--3hCNI"};